import EcoImg from 'eco-design/base/eco-img';
import { getIsMobileWidth } from '@elem/utils/devices';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const isMobile = getIsMobileWidth();
export default function Screen4() {
    const { t } = useLang('theProductV2.Screen4V2');
    const webpOrJpg = useWebpOrJpg('#rapid-mag-Screen4-V2');

    return (
        <section
            className={`${css.comp}  GtmModuleData-section`}
            id="rapid-mag-Screen4-V2"
            data-section-id={'rapid-mag-Screen4-V2'}
            data-section-title={t('title')}
        >
            <div className="text">
                <div className="label">{t('label')}</div>
                <div className="title">{t('title')}</div>
                <div className="desc h5-desc">{t('desc_h5')}</div>
                <div className="desc pc-desc">{t('desc')}</div>
               
                <div className="tips">{t('tips')}</div>
            </div>

            <div className="img-box">
                <EcoImg
                    pc={webpOrJpg(
                        'https://websiteoss.ecoflow.com/upload/image/1764233302835/Screen4.jpg',
                        'https://websiteoss.ecoflow.com/upload/image/1764233319120/Screen4.webp',
                    )}
                     h5={webpOrJpg(
                        'https://websiteoss.ecoflow.com/upload/image/1761547553714/Screen4-m.jpg',
                        'https://websiteoss.ecoflow.com/upload/image/1761547520264/Screen4-m.webp',
                    )}
                />
            </div>
        </section>
    );
}
